.
<template>
  <div class="flow-line">
    <div class="square">
      <span style="--i: 0" />
      <span style="--i: 1" />
      <span style="--i: 2" />
      <span style="--i: 3" />
    </div>
    <div class="square">
      <span style="--i: 0" />
      <span style="--i: 1" />
      <span style="--i: 2" />
      <span style="--i: 3" />
    </div>
    <div class="square">
      <span style="--i: 0" />
      <span style="--i: 1" />
      <span style="--i: 2" />
      <span style="--i: 3" />
    </div>
    <div class="square">
      <span style="--i: 0" />
      <span style="--i: 1" />
      <span style="--i: 2" />
      <span style="--i: 3" />
    </div>
  </div>
</template>
<script setup lang="ts">
defineOptions({
  name: 'VFlowline',
})
</script>
